module.exports = __webpack_public_path__ + "officialStatic/img/pcz.f15f0cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/pcz.png
// module id = ccpd
// module chunks = 0